/* Muse & Fur — Proof Approval Page behavior
   Place in: assets/maf-proof-approval.js
   Link in theme.liquid before </body>:
   <script src="{{ 'maf-proof-approval.js' | asset_url }}" defer></script>

   How it works:
   - Reads order/name/email/proof from the URL query string
   - Stashes them in sessionStorage so they survive the redirect
     Shopify performs after the native contact form submits
   - "Approve" and "Request Changes" both submit the same hidden
     contact form with a different body message
   - On return (?contact_posted=true), shows the right confirmation
     state pulled back out of sessionStorage
*/

(function () {
  var STORAGE_KEY = 'mafProofContext';

  function getParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      order: params.get('order'),
      name: params.get('name'),
      email: params.get('email'),
      proof: params.get('proof')
    };
  }

  function saveContext(context, action) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        order: context.order,
        name: context.name,
        email: context.email,
        action: action
      }));
    } catch (e) {
      // sessionStorage unavailable (private browsing, etc) — non-fatal
    }
  }

  function readSavedContext() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function show(el) {
    if (el) el.hidden = false;
  }

  function hide(el) {
    if (el) el.hidden = true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('[data-maf-proof="container"]');
    if (!container) return; // not on this page

    var missingEl = container.querySelector('[data-maf-proof="missing"]');
    var mainEl = container.querySelector('[data-maf-proof="main"]');
    var confirmationEl = container.querySelector('[data-maf-proof="confirmation"]');
    var confirmationHeading = container.querySelector('[data-maf-proof="confirmation-heading"]');
    var confirmationBody = container.querySelector('[data-maf-proof="confirmation-body"]');
    var orderLabel = container.querySelector('[data-maf-proof="order-label"]');
    var proofImage = container.querySelector('[data-maf-proof="proof-image"]');
    var actions = container.querySelector('[data-maf-proof="actions"]');
    var changesForm = container.querySelector('[data-maf-proof="changes-form"]');
    var approveTrigger = container.querySelector('[data-maf-proof="approve-trigger"]');
    var changesTrigger = container.querySelector('[data-maf-proof="changes-trigger"]');
    var cancelChanges = container.querySelector('[data-maf-proof="cancel-changes"]');
    var submitChanges = container.querySelector('[data-maf-proof="submit-changes"]');
    var notesField = container.querySelector('[data-maf-proof="changes-notes"]');

    var contactForm = document.getElementById('MafProofContactForm');
    var formName = contactForm.querySelector('[data-maf-proof="form-name"]');
    var formEmail = contactForm.querySelector('[data-maf-proof="form-email"]');
    var formBody = contactForm.querySelector('[data-maf-proof="form-body"]');

    var urlParams = new URLSearchParams(window.location.search);
    var returnedFromContact = urlParams.get('contact_posted') === 'true';

    if (returnedFromContact) {
      var saved = readSavedContext();
      hide(missingEl);
      hide(mainEl);
      show(confirmationEl);

      if (saved && saved.action === 'approve') {
        confirmationHeading.textContent = 'Approved — thank you!';
        confirmationBody.textContent = 'Your portrait is now in production. We\u2019ll let you know the moment it ships.';
      } else if (saved && saved.action === 'changes') {
        confirmationHeading.textContent = 'Notes received';
        confirmationBody.textContent = 'Thank you — we\u2019ll review your notes and send an updated proof shortly.';
      } else {
        confirmationHeading.textContent = 'Thank you';
        confirmationBody.textContent = 'We\u2019ve received your response and will follow up shortly.';
      }
      return;
    }

    var context = getParams();

    if (!context.order || !context.proof) {
      show(missingEl);
      return;
    }

    show(mainEl);
    orderLabel.textContent = 'Order ' + context.order;
    proofImage.src = context.proof;

    changesTrigger.addEventListener('click', function () {
      hide(actions);
      show(changesForm);
      notesField.focus();
    });

    cancelChanges.addEventListener('click', function () {
      hide(changesForm);
      show(actions);
    });

    approveTrigger.addEventListener('click', function () {
      formName.value = context.name || 'Customer';
      formEmail.value = context.email || '';
      formBody.value = 'Order ' + context.order + ' — Proof APPROVED for production.';
      saveContext(context, 'approve');
      contactForm.submit();
    });

    submitChanges.addEventListener('click', function () {
      var notes = notesField.value.trim();
      if (!notes) {
        notesField.focus();
        return;
      }
      formName.value = context.name || 'Customer';
      formEmail.value = context.email || '';
      formBody.value = 'Order ' + context.order + ' — Changes requested: ' + notes;
      saveContext(context, 'changes');
      contactForm.submit();
    });
  });
})();
